import { render, staticRenderFns } from "./RevenueSectionWise.vue?vue&type=template&id=6b9c4dee&"
import script from "./RevenueSectionWise.vue?vue&type=script&lang=js&"
export * from "./RevenueSectionWise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports